import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const dueMonthly = Loadable(() =>
  isFuncComp() ? import('../../containers/FunctionalRedesign/dueMonthly') : import('../../containers/web/dueMonthly'),
);

// const dueMonthly = Loadable(() => import('../../containers/web/dueMonthly'));
export default MapTo('vcg/components/soe-home/react/dueMonthly')(dueMonthly);
